import React from "react";
import { Mail } from "lucide-react";
import "./Contact.css";

const Contact = () => {

  return (
    <div className="contact-page">
      <section className="section-padding">
        <div className="container">
          <div className="contact-content">
            <div className="contact-info">
              <h1 className="hero-medium">Contact</h1>
              <p className="body-large">
                We're always open to connecting with builders, potential partners,
                and anyone who shares our approach to making useful software.
              </p>

              <div className="contact-details">
                <div className="contact-item">
                  <Mail className="contact-icon" size={20} />
                  <div>
                    <p className="body-regular">General Inquiries</p>
                    <a
                      href="mailto:hello@harvestholdings.xyz"
                      className="contact-link body-regular"
                    >
                      hello@harvestholdings.xyz
                    </a>
                  </div>
                </div>
              </div>

              <div className="contact-note">
                <p className="body-small">
                  We typically respond within 48 hours. Whether it's a partnership
                  idea, a product question, or an investment inquiry — we'd love
                  to hear from you.
                </p>
              </div>
            </div>

            <div className="contact-form-wrapper">
              <div className="contact-message">
                <h3 className="heading-3">Get In Touch</h3>
                <p className="body-regular">
                  Interested in partnering, building together, or just want to
                  say what's up? Reach out directly via email — we keep things
                  simple and straightforward.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
